import React from 'react'

import ScrollArea from '../../Mantine/ScrollArea'

import * as S from './styles'

export default function Timeline({
  events = [],
  heightPerItem,
  bulletSize = 35,
  active
}) {
  return (
    <div className="teste">
      <ScrollArea
        type="always"
        maxHeight={500}
        height={heightPerItem * events.length}
      >
        <S.Timeline active={active} bulletSize={bulletSize} lineWidth={2}>
          {events.map((event, index) => (
            <S.Timeline.Item
              lineVariant={event.line}
              key={index}
              bullet={
                <img
                  id="icon-timeline"
                  src={event.icon}
                  alt="icon"
                />
              }
              title={event.title}
            >
              <div>{event.description}</div>
              <S.Data size="xs" mt={4}>
                {event.info}
              </S.Data>
            </S.Timeline.Item>
          ))}
        </S.Timeline>
      </ScrollArea>
    </div>
  )
}
